import React, { useEffect, useState } from 'react';
import { Col, message, Row, Tabs, Tag } from 'antd';
import {
  Container,
  MainImage,
  TabContent,
  TagWrapper,
  Title,
} from './styles'

import { useMutation, useQuery } from '@apollo/client';
import { FaArrowLeft, FaCopy } from 'react-icons/fa';
import { useHistory, useParams } from 'react-router-dom';
import { gqlSchema } from '../../../../gql/schema';
import BookInvestigations from './BookInvestigations';
import BookKits from './BookKits';
import AddBookCodes from './AddBookCodes';
import * as S from './styles'
import { IoCloseCircle } from 'react-icons/io5';
import { FiDownload } from 'react-icons/fi';
const { TabPane } = Tabs;

const BookEdit: React.FC = () => {
  const history = useHistory();
  const { bookId } = useParams<{ bookId: string }>();
  const [selectedTab, setSelectedTab] = useState('1');
  const [searchQuery, setSearchQuery] = useState('');
  const [investigations, setInvestigations] = useState([]);


  const { data, refetch } = useQuery(gqlSchema.BookSchema.queries.FetchBookById, {
    variables: {
      id: bookId,
    },
    onError: (error) => {
      message.error(`Error in fetching book details - ${error.message || 'Unexpected Error'}`);
    },
  });

  const { data: invData, refetch: refetchInvestigations } = useQuery(gqlSchema.BookSchema.queries.FetchInvestigationsByBookId, {
    variables: {
      id: bookId,
    },
    onCompleted(data) {
      setInvestigations(data.fetchInvestigationsByBookId);
    },
    onError: (error) => {
      message.error(`Error in fetching book details - ${error.message || 'Unexpected Error'}`);
    },
  });

  const { data: kitData } = useQuery(gqlSchema.BookSchema.queries.FetchKitByBookId, {
    variables: {
      id: bookId,
    },
    onError: (error) => {
      message.error(`Error in fetching book details - ${error.message || 'Unexpected Error'}`);
    },
  });
  const { data: bookCodes, refetch: refetchCodes, loading } = useQuery(gqlSchema.BookSchema.queries.GetUnusedCodes, {
    variables: {
      bookId: bookId,
      limit: 1000
    },
    fetchPolicy: 'network-only',
    onError: (error) => {
      message.error(`Error in fetching book details - ${error.message || 'Unexpected Error'}`);
    },
  });

  const { data: UsedBookCodes, refetch: refetchUsedBookCodes } = useQuery(gqlSchema.BookSchema.queries.GetUsedCodes, {
    variables: {
      bookId: bookId,
      limit: 1000
    },
    fetchPolicy: 'network-only',
    onError: (error) => {
      message.error(`Error in fetching book details - ${error.message || 'Unexpected Error'}`);
    },
  });
  const [assignInvestigationKitBundle] = useMutation(gqlSchema.BookSchema.mutations.AssignInvestigationKitBundle, {
    onCompleted: () => {
      message.success('Investigations Updated successfully');
      refetch()
    },
    onError: (error: any) => {
      message.error(`Error in assigning investigation kit bundle - ${error.message || 'Unexpected Error'}`);
    },
  });
  const onDelete = async (investigationId: string) => {
    try {
      const finalData = invData?.fetchInvestigationsByBookId
        ?.filter((i: any) => i.id !== investigationId)
      setInvestigations(finalData);
      const finalIds = finalData.map((i: any) => i.id);
      await assignInvestigationKitBundle({
        variables: {
          bookId,
          investigationIds: finalIds,
        },
      });
      message.success('Investigation deleted successfully');
    } catch (error) {
      console.error('Error assigning investigation kit bundle:', error);
      message.error('Failed to delete investigation');
    }
  };

  const handleCopy = (text: string) => {
    navigator.clipboard.writeText(text).then(() => {
      message.success('Code copied to clipboard');
    }).catch(err => {
      message.error('Failed to copy code');
    });
  };

  const handleDownloadCSV = (data:any,used:boolean) => {
    if (!data?.length) return;

    if(!used){
       const csvHeader = "Index,Code,BookName\n";
    const csvRows = data
      .map((code: any, idx: number) => `${idx + 1},"${code.code}","${bookData.title}"`)
      .join("\n");

    const csvContent = csvHeader + csvRows;

    const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
    const url = URL.createObjectURL(blob);
    const link = document.createElement("a");
    link.href = url;
    link.setAttribute("download", "UnUsedBookCodes.csv");
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);

    }else
    {
       const csvHeader = "Index,Code,BookName,Email,UserName\n";
    const csvRows = data
      .map((code: any, idx: number) => `${idx + 1},"${code.code}","${bookData.title}",${code.email},${code.userName}`)
      .join("\n");

    const csvContent = csvHeader + csvRows;

    const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
    const url = URL.createObjectURL(blob);
    const link = document.createElement("a");
    link.href = url;
    link.setAttribute("download", "UsedBookCodes.csv");
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);

    }


   
  };


  useEffect(() => {
    if (invData?.fetchInvestigationsByBookId) {
      setInvestigations(invData.fetchInvestigationsByBookId);
    }
  }, [invData]);


  const bookData = data?.fetchBookById;
  const investigationsData = investigations || [];
  const kitsData = kitData?.fetchKitByBookId || [];
  const codeData = bookCodes?.getUnusedCodes || [];
  const usedCodeData = UsedBookCodes?.getUsedBookCodes || [];
  const filteredData = codeData.filter((code: any) =>
    code.code.toLowerCase().includes(searchQuery.toLowerCase())
  );
  const UsedFilteredData = usedCodeData.filter((code: any) =>
    code.code.toLowerCase().includes(searchQuery.toLowerCase())
  );

  return (
    <Container>
      <FaArrowLeft onClick={() => history.push('/bookadmin')} size={16} cursor={'pointer'} />
      <Row gutter={24}>
        <Col span={10} style={{ display: 'flex', alignItems: 'flex-start' }}>

          <MainImage
            src={
              bookData?.imageUrl?.[0]
            }
            alt="Main Book Cover"
          />
        </Col>
        <Col span={14} style={{ display: 'flex', justifyContent: 'flex-start', flexDirection: 'column', gap: '8px' }}>
          <Title>{bookData?.title}</Title>
          <TagWrapper>

            <Tag
              color="#4367E9"
              style={{
                color: '#4367E9',
                fontWeight: 600,
                borderColor: '#4367E9',
                backgroundColor: 'white',
                borderRadius: '16px',
              }}
            >
              {investigationsData?.length || 0} Investigation
            </Tag>
          </TagWrapper>

          <div>

          </div>
          <Tabs onChange={(key) => setSelectedTab(key)} defaultActiveKey="1">

            <TabPane tab="Investigation List" key="1">
              <TabContent>
                <ul>
                  {investigationsData.map((investigation: any, idx: number) => {
                    return <li key={investigation.id}>{` ${idx + 1}: ${investigation.title}`} <IoCloseCircle onClick={() => onDelete(investigation.id)} size={20} style={{ cursor: 'pointer', top: '2px' }} /></li>
                  })}
                </ul>
              </TabContent>
            </TabPane>

            <TabPane tab="Related kits" key="2">
              <TabContent>
                <ul>
                  <li>
                    {kitsData?.title ? (
                      kitsData.handle ? (
                        <a href={`https://shop.argumentdriveninquiry.com/products/${kitsData.handle}`} target="_blank" rel="noopener noreferrer">
                          {kitsData.title}
                        </a>
                      ) : (
                        kitsData.title
                      )
                    ) : (
                      <span>No title available.</span>
                    )}
                  </li>
                </ul>
                {!kitsData && <p>No kits available.</p>}
              </TabContent>


            </TabPane>
            <TabPane tab="Book Codes" key="3">
              <TabContent>
                <TabContent>
                  <div
                    style={{
                      display: 'flex',
                      alignItems: 'center',
                      //justifyContent: 'flex-end',
                      paddingRight: '24px', // keep space from right edge
                      marginBottom: '16px',
                      gap: '12px', // space between icon and input
                    }}
                  >

                    <input
                      type="text"
                      placeholder="Search..."
                      value={searchQuery}
                      onChange={(e) => setSearchQuery(e.target.value)}
                      style={{
                        width: '260px',
                        padding: '8px',
                        borderRadius: '4px',
                        border: '1px solid #ccc',
                      }}
                    />
                    <FiDownload
                      onClick={()=>handleDownloadCSV(filteredData,false)}
                      title="Download Unused Book Codes in CSV"
                      style={{
                        fontSize: '35px',
                        color: '#4367E9',
                        cursor: 'pointer',
                        padding: '6px',
                        border: '1px solid #ccc',
                        borderRadius: '4px',
                        backgroundColor: '#fff',
                      }}
                    />
                  </div>


                </TabContent>


                <ul>
                  {filteredData.map((code: any, idx: number) => (
                    <li key={code.id || idx}>{` ${idx + 1}: ${code.code}`} <FaCopy onClick={() => handleCopy(code.code)} style={{ cursor: 'pointer' }} /></li>

                  ))}
                </ul>
              </TabContent>
            </TabPane>
          <TabPane tab="Used Book Codes" key="4">

  <TabContent>
    <S.ActionBar>
      <S.SearchInput
        type="text"
        placeholder="Search by email or code..."
        value={searchQuery}
        onChange={(e) => setSearchQuery(e.target.value)}
      />
      <S.IconButton
        onClick={()=>handleDownloadCSV(UsedFilteredData,true)}
        title="Download Used Book Codes in CSV"
      >
        <FiDownload size={24} />
      </S.IconButton>
    </S.ActionBar>

    <S.StyledTable>
      <thead>
        <tr>
          <th>Email</th>
          <th>Code</th>
          <th>User Name</th>
        </tr>
      </thead>
      <tbody>
        {UsedFilteredData.map((item:any) => (
          <tr key={item.id}>
            <td>{item?.email || 'N/A'}</td>
            <td>{item.code}</td>
              <td>{item.userName||'N/A'}</td>
            {/* <td style={{ textAlign: 'center' }}>
              <S.IconButton
                onClick={() => handleCopy(item.code)}
                title={`Copy code ${item.code}`}
              >
                <FaCopy size={18} />
              </S.IconButton>
            </td> */}
          </tr>
        ))}
      </tbody>
    </S.StyledTable>
  </TabContent>
</TabPane>

          </Tabs>
        </Col>
      </Row>
      <S.Divider />
      {
        selectedTab === '1' && <BookInvestigations selectedInvestigations={investigationsData} refetchBook={refetch} bookId={bookId} refetchInvestigations={refetchInvestigations} />
      }
      {
        selectedTab === '2' && <BookKits selectedKits={kitsData} refetchBook={refetch} bookId={bookId} />
      }
      {
        selectedTab === '3' && <AddBookCodes
          refetchCodes={refetchCodes}
          shopifyProductId={bookId}
          codeData={codeData}
          loading={loading} />
      }
      {
        selectedTab === '4' && <AddBookCodes
          refetchCodes={refetchUsedBookCodes}
          shopifyProductId={bookId}
          codeData={usedCodeData}
          loading={loading} />
      }


    </Container>
  );

};


export default BookEdit;
